import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Banner from "../Components/Shared/Layout/Banner";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import withLanguage from "../HOC/withLanguage";

function PracticeDual({ language}) {
    const lang = useSelector((state) => state.language.currentLanguage);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        const ac = new AbortController();
        setLoading(true);
        setErr(null);

        // list endpoint + ?lang
        const url = `/api/dual_system/professional_dual_system?lang=${encodeURIComponent(
            lang || "al"
        )}`;

        fetch(url, { signal: ac.signal })
            .then(async (r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then((data) => setItems(Array.isArray(data?.records) ? data.records : []))
            .catch((e) => {
                if (e.name !== "AbortError") setErr(e.message || "Failed to load");
            })
            .finally(() => setLoading(false));

        return () => ac.abort();
    }, [lang]);

    const truncate = (str, max = 300) =>
        typeof str === "string" && str.length > max ? str.slice(0, max).trim() + " […]" : str ?? "";

    return (
        <>
            <Banner img="/howToApplyImages/banner.jpg" title={language?.banner} />
            <IntroBlock>{language.p1}</IntroBlock>
            <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">

                {loading && <div className="p-6 text-center">Loading…</div>}
                {err && <div className="p-6 text-center text-red-600">Error: {err}</div>}

                {!loading && !err && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
                        {items.map((it) => {
                            const imgSrc = it?.image ? `data:image/jpeg;base64,${it.image}` : null;
                            return (
                                <article
                                    key={it.id}
                                    className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col"
                                >
                                    {/* image */}
                                    {imgSrc && (
                                        <div className="w-full aspect-[4/3] bg-gray-100">
                                            <img
                                                src={imgSrc}
                                                alt={it?.title || "Blog image"}
                                                className="w-full h-full object-cover"
                                                loading="lazy"
                                            />
                                        </div>
                                    )}

                                    {/* content */}
                                    <div className="p-6 flex flex-col grow">
                                        <h3 className="font-semibold text-xl leading-6 mb-3">
                                            {it?.title || ""}
                                        </h3>

                                        <p className="text-sm text-gray-800 leading-6 flex-1">
                                            {truncate(it?.description, 420)}
                                        </p>

                                        <div className="mt-4">
                                            <Link
                                                to={`/blog/${it.id}`}
                                                className="inline-flex items-center gap-2 text-sm font-medium text-white bg-gray-900 rounded-lg px-4 py-2"
                                            >
                                                <span className="inline-flex items-center justify-center w-4 h-4 border rounded-full">
                                                    <span className="w-1.5 h-1.5 bg-white rounded-full" />
                                                </span>
                                                {language['read_more']}
                                            </Link>
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                )}
            </div>
        </>
    );
}

export default withLanguage(PracticeDual, "PracticeDual");
